import {ConflictError} from '@packages/utils';
import {DUPLICATED_EMAIL_MESSAGE} from '../../entities/mypage/emailConstants';

// APIが409のレスポンスに含める重複対象の識別子
const AC_EMAIL_CONFLICT = 'ac email';
const PRIVATE_EMAIL_CONFLICT = 'private email';

type DuplicatedEmailErrors = {
  acEmail?: string;
  privateEmail?: string;
};

// 409のときだけ ClientContextClass が responseData 付きの Error を throw する
type DuplicatedEmailError = {
  responseData?: {message?: string};
};

export const isDuplicatedEmailError = (
  error: unknown,
): error is DuplicatedEmailError =>
  typeof error === 'object' &&
  error !== null &&
  (error as {message?: unknown}).message === ConflictError;

// 重複したメールアドレスの入力欄にだけエラーを表示する。
// 識別子が無い場合はどちらか判別できないため、従来どおり両方に表示する。
export const buildDuplicatedEmailErrors = (
  responseMessage?: string,
): DuplicatedEmailErrors => {
  if (responseMessage?.includes(AC_EMAIL_CONFLICT)) {
    return {acEmail: DUPLICATED_EMAIL_MESSAGE};
  }

  if (responseMessage?.includes(PRIVATE_EMAIL_CONFLICT)) {
    return {privateEmail: DUPLICATED_EMAIL_MESSAGE};
  }

  return {
    privateEmail: DUPLICATED_EMAIL_MESSAGE,
    acEmail: DUPLICATED_EMAIL_MESSAGE,
  };
};
